module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/reviews-powered-by-google-2f0408b28f9eeac8e0fe89179df3884d.svg";